import { defineStore } from 'pinia'

const defaultState = {
  faq: {
    docSrc: 'https://docs.google.com/document/d/e/2PACX-1vRUiOKe9OQsRu9dhQSb2siK67Bq6AfqjCcsDBdw63WYfw0ZC9Aa1MY9WNyP6_hYqw/pub?embedded=true',
    classes: ''
  },
  terms: {
    docSrc: 'https://docs.google.com/document/d/e/2PACX-1vTlrYpHfkIElsT-3_qcYyp3gN6relEIU-4nXQ66ojw_zKR9j6WoYWv2KUO35l67dw/pub?embedded=true',
    classes: ''
  },
  retailers: {
    docSrc: '',
    classes: ''
  }
}

export default defineStore('embed', {
  state: () => defaultState,
  getters: {},
  actions: {}
})
